<template>
    <dragable-popper
        v-show="visible"
        ref="code-review" 
        class="code-preview" 
        :width="320"
        :height="180"
        top="160px"
        :right="this.showSimulator ? 'calc(24% + 100px)' : '100px'"
    >
        <div slot="title" :class="shit$(`w:100%; mih:30px; lh:30px; font:12px; text-a:center; c:#ffffff; bgc:#333333; letter-s:0.8px;`)">
            {{$t("LANG_TITLE_TEXT_CODE_PANEL")}}
        </div>
        <div slot="content" class="code-preview-content">
            <el-input
                type="textarea"
                :value="code"
            ></el-input>
        </div>
    </dragable-popper>
</template>

<script>
import DragablePopper from '@/code-lab/view/dragable-popper'
import { mapState } from 'vuex'
export default {
    name: "code-preview",
    components: {
        DragablePopper
    },
    props: {
        code: String,
        visible: Boolean
    },
    computed: {
        ...mapState([
            'showSimulator'
        ])
    }
}
</script>

<style lang="scss">
.code-preview {
    width: 320px;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.7);
    border-radius: 24px;
    overflow: hidden;
    .code-preview-content {
        background: #444;
        .el-textarea {
            .el-textarea__inner {
                width: 100%;
                padding: 10px 20px 25px 15px;
                background: none;
                border: none;
                outline: none;
                color: #ffffff;
                font-size: 12px;
                height: 150px;
                line-height: 1.92;
                font-weight: 600;
                overflow: auto;
                resize: none;
                cursor: default;
            }
        }
    }
}
</style>
